/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Generate_ImageInputs */

const cs_social_export_generate_image = /** @type {(inputs: Social_Export_Generate_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generovat obrázek`)
};

const en_social_export_generate_image = /** @type {(inputs: Social_Export_Generate_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate image`)
};

/**
* | output |
* | --- |
* | "Generate image" |
*
* @param {Social_Export_Generate_ImageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_generate_image = /** @type {((inputs?: Social_Export_Generate_ImageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Generate_ImageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_generate_image(inputs)
	return cs_social_export_generate_image(inputs)
});